import React from 'react';
import { Link } from 'react-router-dom';
import './Pages.css';

function SolutionsPage() {
  const solutions = [
    {
      title: "Bulk Export Supply (B2B)",
      features: [
        "Bulk supply for importers, distributors, and manufacturers",
        "Standard bulk packs available",
        "Export documentation support included"
      ]
    },
    {
      title: "Wholesale Supply (Large Quantity Orders)",
      features: [
        "Best pricing for large-volume requirements",
        "Suitable for long-term supply contracts",
        "Priority dispatch planning available"
      ]
    },
    {
      title: "Private Label Packaging",
      features: [
        "Retail-ready packing support",
        "Preferred pack sizes: 100g & 250g (Matte finish)",
        "Custom labels and carton packing available"
      ]
    },
    {
      title: "Custom Product Sourcing & Multi-Product Orders",
      features: [
        "Multiple products in one shipment",
        "Custom mesh sizes (on request)",
        "Custom blending support (on request)"
      ]
    }
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Solutions</h1>
        <div className="title-underline"></div>
      </div>
      
      <div className="page-intro">
        <p>HOPE INTERNATIONAL is more than a supplier — we support buyers with consistent sourcing, export-ready documentation, and flexible packaging options for global trade.</p>
      </div>

      <div className="solutions-grid">
        {solutions.map((solution, index) => (
          <div key={index} className="solution-card">
            <h3>{solution.title}</h3>
            <ul>
              {solution.features.map((feature, idx) => (
                <li key={idx}>{feature}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="page-cta-section">
        <h3>Share your requirement and we will send a quotation quickly.</h3>
        <div className="cta-buttons">
          <Link to="/request-quote" className="btn-primary">Request a Quote</Link>
          <Link to="/request-sample" className="btn-secondary">Request a Sample</Link>
        </div>
      </div>
    </div>
  );
}

export default SolutionsPage;
